// extracted by mini-css-extract-plugin
export var errorIcon = "_kg-1";
export var nameLogo = "_kg-0";